import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const hoverCardStyleId = 'wb-v2-hover-card-theme';

/** Sits on the shared dark `wb-dark-tooltip` surface, so text is the on-brand token; title and labels are the same colour dimmed. */
export const hoverCardBridgeStyles = {
  'wb-hover-card': {
    '--local-hover-card-gap': tokens.spacing.xs,
    '--local-hover-card-label-gap': tokens.spacing.xs,
    '--local-hover-card-text': tokens.color.text.primaryOnBrand,
    '--local-hover-card-title-size': tokens.font.size.textXs,
    '--local-hover-card-title-line-height': tokens.lineHeight.textXs,
    '--local-hover-card-text-size': tokens.font.size.textSm,
    '--local-hover-card-text-line-height': tokens.lineHeight.textSm,
    '--local-hover-card-max-width': '320px',
  },
};
